// extracted by mini-css-extract-plugin
export default {"tableWrap":"InvoicesGrid_tableWrap__RRBVO"};